import React from 'react';
import classNames from 'classnames';

import Icon from 'shared/components/icon';
import {isActivePath} from './is-active-path';
import {NavbarMenuListProps} from './NavbarMenuList';
import NavbarLink from './NavbarLink/NavbarLink';
import MobileNavbarMenu from './MobileNavbarMenu/MobileNavbarMenu';
import styles from './styles.module.scss';

const MobileNavbarMenuList = ({menus, routed, experienceEverywhere}: NavbarMenuListProps) => (
  <>
    {menus?.map((menu) => {
      const pathsToCheck =
        'menuItems' in menu ? menu.menuItems?.map(({path}) => path) || [] : [menu.path];
      const isActiveLink = isActivePath(pathsToCheck, location);

      const title = (
        <div className={styles.title}>
          {menu.iconType && (
            <Icon
              iconType={menu.iconType}
              className={classNames(styles.drawerIcon, {
                [styles.experienceEverywhereDrawer]: experienceEverywhere,
              })}
            />
          )}
          {menu.title}
        </div>
      );

      return 'menuItems' in menu ? (
        <MobileNavbarMenu
          title={title}
          menuItems={menu.menuItems}
          key={menu.title}
          routed={routed}
          className={classNames({[styles.activeDrawerLink]: isActiveLink})}
          experienceEverywhere={experienceEverywhere}
        />
      ) : (
        <NavbarLink
          key={menu.title}
          to={menu.path}
          title={title}
          routed={menu.routed}
          className={classNames(styles.drawerLink, {
            [styles.activeDrawerLink]: isActiveLink,
            [styles.experienceEverywhereDrawer]: experienceEverywhere,
          })}
        />
      );
    })}
  </>
);

export default MobileNavbarMenuList;
